import {style} from '@vanilla-extract/css'

export const searchInput = style({
  margin: '10px',
})
